import React from "react";
import { Link } from "react-router-dom";
import { rupees } from "../Insights/format";
import { paymentSplit } from "./paymentSplit";

const Money = ({ value, strong }) => (
  <span className={!value ? "stl-zero" : strong ? "stl-strong" : undefined}>{rupees(value)}</span>
);

const PaymentMethod = ({ row }) => {
  const { label, tone, refund } = paymentSplit(row);
  return (
    <>
      <span className={`rider-pay rider-pay--${tone}`}>{label}</span>
      {refund && <span className="rider-pay-refund">{refund}</span>}
    </>
  );
};

const AMOUNTS = [
  ["food_and_store", "Food + Store charge"],
  ["delivery_charge", "Delivery charge"],
  ["surge", "Surge"],
  ["tip", "Tip"],
];

export default function RiderOrders({ rows, loading }) {
  return (
    <div className="stl-scroll">
      <table className="stl-table">
        <thead>
          <tr>
            <th className="stl-left">Order ID</th>
            {AMOUNTS.map(([key, title]) => (
              <th key={key}>{title}</th>
            ))}
            <th>Total</th>
            <th className="stl-left">Payment method</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={AMOUNTS.length + 3} className="stl-no-match">
                {loading ? "Loading orders…" : "No delivered orders in this period"}
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.order_id}>
                <td className="stl-left">
                  <Link className="rider-order-link" to={`/orderID/${row.order_id}`}>
                    #{row.order_id}
                  </Link>
                </td>
                {AMOUNTS.map(([key]) => (
                  <td key={key}>
                    <Money value={row[key]} />
                  </td>
                ))}
                <td>
                  <Money value={row.total} strong />
                </td>
                <td className="stl-left">
                  <PaymentMethod row={row} />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
